const t = (i) => ({
  wrapper: {
    backgroundColor: i.palette.common.white
  },
  heading: {
    color: i.palette.common.blue400,
    "@media(max-width: 600px)": {
      fontSize: i.typography.fontSize22
    }
  },
  description: {
    color: i.palette.common.grey300,
    "@media(max-width: 600px)": {
      fontSize: i.typography.fontSize14
    }
  },
  card: {
    padding: 24,
    borderColor: i.palette.common.grey50,
    boxShadow: "none",
    "@media(max-width: 600px)": {
      padding: 0,
      borderColor: "transparent"
    }
  },
  title: {
    color: i.palette.common.blue400,
    "@media(max-width: 600px)": {
      fontSize: i.typography.fontSize18
    }
  },
  divider: {
    background: i.palette.common.grey30,
    height: 2,
    margin: "24px 0",
    "@media(max-width: 600px)": {
      margin: "16px 0"
    }
  },
  featureTitle: {
    color: i.palette.common.blue400,
    fontWeight: i.typography.fontWeightBold
  },
  featureList: {
    "@media(max-width: 600px)": {
      display: "flex",
      flexWrap: "wrap",
      "& > li:nth-child(even)": {
        paddingLeft: 8
      },
      "& > li:nth-child(odd)": {
        paddingRight: 8
      }
    }
  },
  featureItem: {
    paddingLeft: 0,
    paddingRight: 0,
    "@media(max-width: 600px)": {
      width: "50%"
    }
  },
  featureText: {
    color: i.palette.common.blue400
  },
  carouselImg: {
    height: "inherit"
  },
  sliderWrapper: {
    display: "block",
    height: "100%",
    "& .slick-slider": {
      position: "relative",
      display: "block",
      boxSizing: "border-box",
      userSelect: "none",
      touchAction: "pan-y",
      tapHighlightColor: "transparent",
      height: "inherit"
    },
    "& .slick-list": {
      position: "relative",
      display: "block",
      overflow: "hidden",
      margin: 0,
      padding: 0,
      height: "inherit",
      "&:focus": {
        outline: "none"
      },
      "&.dragging": {
        cursor: "hand"
      }
    },
    "& .slick-slider .slick-track, & .slick-slider .slick-list": {
      transform: "translate3d(0, 0, 0)"
    },
    "& .slick-track": {
      position: "relative",
      top: 0,
      left: 0,
      display: "block",
      marginLeft: "auto",
      marginRight: "auto",
      height: "inherit",
      "&:before, &:after": {
        display: "table",
        content: '""'
      },
      "&:after": {
        clear: "both"
      }
    },
    "& .slick-loading .slick-track": {
      visibility: "hidden"
    },
    "& .slick-slide": {
      display: "none",
      float: "left",
      minHeight: 1,
      height: "inherit"
    },
    "& [dir='rtl'] .slick-slide ": {
      float: "right"
    },
    "& .slick-slide > div": {
      height: "inherit"
    },
    "& .slick-slide img": {
      display: "block",
      width: "100%",
      height: "100%",
      borderRadius: 4
    },
    "& .slick-slide.slick-loading img": {
      display: "none"
    },
    "& .slick-slide.dragging img": {
      pointerEvents: "none"
    },
    "& .slick-initialized .slick-slide": {
      display: "block"
    },
    "& .slick-loading .slick-slide": {
      visibility: "hidden"
    },
    "& .slick-vertical .slick-slide": {
      display: "block",
      height: "auto",
      border: "1px solid transparent"
    },
    "& .slick-arrow.slick-hidden": {
      display: "none"
    },
    // arrow and dots section styling
    "& .slick-loading .slick-list": {
      background: `${i.palette.common.white} url("./ajax-loader.gif") center center no-repeat`
    },
    "& .slick-prev, & .slick-next": {
      fontSize: 0,
      lineHeight: 0,
      position: "absolute",
      top: "50%",
      display: "block",
      width: 32,
      height: 32,
      padding: "7px 0",
      transform: "translate(0, -50%)",
      cursor: "pointer",
      color: "transparent",
      outline: "none",
      background: i.palette.common.white,
      zIndex: 9,
      border: `1px solid ${i.palette.common.grey100}`,
      borderRadius: "100%",
      "& .MuiIconButton-label": {
        color: i.palette.common.white
      },
      "&:hover, &:focus": {
        color: "transparent",
        outline: "none",
        background: i.palette.common.white,
        "&:before": {
          opacity: 1
        }
      }
    },
    "& .slick-prev.slick-disabled:before, & .slick-next.slick-disabled:before": {
      opacity: 0.25
    },
    "& .slick-prev": {
      left: 16,
      "@media(max-width: 1360px)": {
        left: 16
      }
    },
    '& [dir="rtl"] .slick-prev': {
      right: 16,
      left: "auto",
      "@media(max-width: 1360px)": {
        right: 16
      }
    },
    "& .slick-next": {
      right: 16,
      "@media(max-width: 1360px)": {
        right: 16
      }
    },
    '& [dir="rtl"] .slick-next': {
      right: "auto",
      left: 16,
      "@media(max-width: 1360px)": {
        left: 16
      }
    },
    // '& [dir="rtl"] .slick-next:before': {
    //   content: '"←"'
    // },
    "& .slick-dotted.slick-slider": {
      marginBottom: 30
    },
    "& .slick-dots": {
      position: "absolute",
      bottom: 24,
      display: "block",
      width: "100%",
      padding: 0,
      margin: 0,
      listStyle: "none",
      textAlign: "center"
    },
    "& .slick-dots li": {
      position: "relative",
      display: "inline-block",
      width: 6,
      height: 6,
      margin: "0 2px",
      padding: 0,
      cursor: "pointer"
    },
    "& .slick-dots li.slick-active": {
      width: 10,
      height: 10
    },
    "& .slick-dots li button": {
      fontSize: 0,
      lineHeight: 0,
      display: "block",
      width: 6,
      height: 6,
      padding: 0,
      cursor: "pointer",
      color: "transparent",
      border: 0,
      outline: "none",
      background: i.palette.common.white,
      borderRadius: "100%",
      opacity: 0.4,
      "&:hover, &:focus": {
        outline: "none"
      }
    },
    "& .slick-dots li button:hover, & .slick-dots li button:focus:before": {
      opacity: 1
    },
    "& .slick-dots li.slick-active button": {
      width: 10,
      height: 10,
      opacity: 1
    }
  },
  quoteBtn: {
    maxWidth: 260,
    textTransform: "capitalize",
    "@media(max-width: 600px)": {
      maxWidth: "100%"
    }
  }
}), e = t;
export {
  e as default
};
